import * as xlsx from 'xlsx';
import {
  CREATE_QUESTIONS,
  DELETE_QUESTIONS,
  GET_QUESTIONS,
} from '../store/questions/actions/actionTypes';

export default {
  methods: {
    exportInstructionsData() {
      const workSheetInstructions = [];
      const header = {
        header: ['Type', 'Question', 'Picture Mandatory', 'Sub-Instruction'],
      };
      const hasOtherOptions = this.taskQuestions.some((task) => {
        if (
          (task.type === 'multiplechoice' || task.type === 'singlechoice') &&
          Array.isArray(task.multipleChoices)
        ) {
          return true;
        }
        return false;
      });

      if (hasOtherOptions) {
        header.header.push('Other');
      }

      const { taskQuestions } = this;
      taskQuestions.forEach((task) => {
        let hasOther = false;
        if (
          (task.type === 'multiplechoice' || task.type === 'singlechoice') &&
          Array.isArray(task.multipleChoices)
        ) {
          hasOther = task.multipleChoices.some((opt) => opt.other);
        }

        const row = {
          Type: task.type,
          Question: task.question,
          'Picture Mandatory': task.isPictureMandatory,
          'Sub-Instruction': !!task.parentId,
        };

        if (hasOtherOptions) {
          row.Other = hasOther;
        }

        if (
          (task.type === 'multiplechoice' || task.type === 'singlechoice') &&
          Array.isArray(task.multipleChoices)
        ) {
          task.multipleChoices
            .filter((opt) => !opt.other)
            .forEach((option, index) => {
              row[`Option ${index + 1}`] = option.defaultMC;
            });
        }
        if (row.Type === 'action') {
          row.Type = 'Action';
        }
        if (row.Type === 'yesno') {
          row.Type = 'Yes/No';
        }
        if (row.Type === 'textnumber') {
          row.Type = 'Text';
        }
        if (row.Type === 'multiplechoice') {
          row.Type = 'Multiple Choice';
        }
        if (row.Type === 'singlechoice') {
          row.Type = 'Single Choice';
        }
        if (row.Type === 'tablequestion') {
          row.Type = 'Table';
        }
        if (row.Type === 'importcsv') {
          row.Type = 'Table';
        }

        workSheetInstructions.push(row);
      });

      const workbook = xlsx.utils.book_new();
      const instructionSheet = xlsx.utils.json_to_sheet(
        workSheetInstructions,
        header
      );

      xlsx.utils.book_append_sheet(workbook, instructionSheet, 'Instructions');

      const now = new Date();
      const datetimeString = `${now.getFullYear()}${now.getMonth()}${now.getDate()}${now.getHours()}${now.getMinutes()}`;
      const fileName = 'Instructions List';

      xlsx.writeFile(
        workbook,
        `${fileName} - ${this.currentTask.title} - ${datetimeString}.xlsx`
      );
    },

    readInstructionFile(binary) {
      const workbook = xlsx.read(binary, {
        type: 'binary',
      });

      const workSheet = xlsx.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        {
          header: 1,
        }
      );

      const headers = workSheet[0].map((header) => header.toLowerCase());
      workSheet.splice(0, 1);

      const instructionsData = [];

      if (headers.length !== 0) {
        const typeLocation = headers.indexOf('type');
        const questionLocation = headers.indexOf('question');
        const picturemandatoryLocation = headers.indexOf('picture mandatory');
        const otherLocation = headers.indexOf('other');
        const isSubInstructionLocation = headers.indexOf('sub-instruction');
        let validHeader = false;
        validHeader =
          typeLocation !== -1 &&
          questionLocation !== -1 &&
          picturemandatoryLocation !== -1;

        if (!validHeader) {
          this.$buefy.toast.open({
            duration: 5000,
            message: this.$t('instructions_excel_import_failed'),
            type: 'is-danger',
          });

          this.isLoadingTask = false;
          return;
        }

        let labelCounter = 0;
        const regextype =
          /^(action|text|yes\/no|multiple choice|single choice|table)$/;

        let allTypesValid = true;
        const invalidTypes = [];

        // First pass: validate all types
        workSheet.forEach((row, index) => {
          const emptyRow =
            !row[typeLocation] &&
            !row[questionLocation] &&
            !row[picturemandatoryLocation];

          if (!emptyRow) {
            const type = row[typeLocation]?.toLowerCase();
            if (!regextype.test(type)) {
              invalidTypes.push({ rowIndex: index + 1, type });
              allTypesValid = false;
            }
          }
        });

        if (!allTypesValid) {
          let errorMessage =
            'The following instructions have an invalid type:<br>';
          invalidTypes.forEach((item) => {
            errorMessage += `Instruction ${item.rowIndex}: "${item.type}"<br>`;
          });

          this.$buefy.snackbar.open({
            message: errorMessage,
            type: 'is-danger',
            position: 'is-top',
            duration: 8000,
            pauseOnHover: true,
          });
          this.$refs.importAdd.value = '';
          this.isLoadingTask = false;
          return;
        }

        let subLabelCounter = 1;
        workSheet.forEach((row) => {
          const emptyRow =
            !row[typeLocation] &&
            !row[questionLocation] &&
            !row[picturemandatoryLocation];

          if (!emptyRow) {
            let type = row[typeLocation]?.toLowerCase();

            if (type === 'Action') {
              type = 'action';
            }
            if (type === 'text') {
              type = 'textnumber';
            }
            if (type === 'yes/no') {
              type = 'yesno';
            }
            if (type === 'multiple choice') {
              type = 'multiplechoice';
            }
            if (type === 'single choice') {
              type = 'singlechoice';
            }
            if (type === 'table') {
              type = 'tablequestion';
              this.$buefy.snackbar.open({
                message:
                  'Warning: Uploaded Table instructions will be created as blank tables.',
                type: 'is-warning',
                position: 'is-top',
                duration: 8000,
                pauseOnHover: true,
              });
            }

            if (!row[isSubInstructionLocation]) {
              subLabelCounter = 1;
              labelCounter++;
            }

            const instruction = {
              label: labelCounter,
              type: type || '',
              question: row[questionLocation] || '',
              isPictureMandatory: row[picturemandatoryLocation] || '',
              isSubInstruction: row[isSubInstructionLocation] || false,
              subLabel: row[isSubInstructionLocation]
                ? subLabelCounter++
                : null,
            };

            if (type === 'multiplechoice' || type === 'singlechoice') {
              const multipleChoices = [];
              headers.forEach((header, index) => {
                if (header.toLowerCase().startsWith('option')) {
                  const value = String(row[index] || '');
                  if (value) {
                    multipleChoices.push({
                      checked: false,
                      defaultMC: value,
                    });
                  }
                }
              });

              if (row[otherLocation]) {
                multipleChoices.push({
                  checked: false,
                  defaultMC: '',
                  other: true,
                });
              }

              instruction.multipleChoices = multipleChoices;
            }
            if (type === 'tablequestion') {
              const tableData = [
                ['', '-', '-'],
                ['1', '', ''],
                ['2', '', ''],
                ['3', '', ''],
              ];
              instruction.tableData = tableData;
              instruction.tableRow = 3;
              instruction.tableColumn = 2;
              instruction.dimensions = '3 X 2';
            }

            instructionsData.push(instruction);
          }
        });
        return instructionsData;
      }
    },
    handleInstructionImportAdd(event) {
      this.isLoadingTask = true;
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = (onloadEvent) => {
        const processFile = async () => {
          try {
            const importedInstructions = this.readInstructionFile(
              onloadEvent.target.result
            );
            if (!importedInstructions) {
              return;
            }
            await this.$store.dispatch(DELETE_QUESTIONS, this.currentTask._id);

            const importedRows = [];
            importedInstructions.forEach((row) => {
              importedRows.push(row);
            });

            await this.$store.dispatch(CREATE_QUESTIONS, {
              taskId: this.currentTask._id,
              questions: importedRows,
            });
            await this.$store.dispatch(GET_QUESTIONS, this.currentTask._id);
          } catch (error) {
            console.error('Error during instruction import:', error);

            this.$buefy.snackbar.open({
              message:
                'An unexpected error occurred while importing the worksheet.',
              type: 'is-danger',
              position: 'is-top',
              duration: 5000,
              pauseOnHover: true,
            });
          }
          this.isLoadingTask = false;
        };
        processFile();
      };
      fileReader.readAsBinaryString(file);
    },
  },
};
